/* Berry theme · search (D4a). Ported from the prototype (site.js "Predictive search", pages.js R.search):
     · header search panel: while the client types (two letters or more, 120ms after the last key), Shopify's
       Predictive Search API returns the section predictive-search (suggestions, categories, help pages, four pieces);
       a light skeleton shows if the answer takes longer than 200ms; a tap on a suggestion or a popular search fills the
       field and shows its results; Enter opens the full results page
     · results page: the two tabs (Pieces · Categories & help) follow the ARIA tabs pattern (arrow keys, Home, End)
   Loaded on every page (the search panel lives in the header). */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const BV = (window.BV = window.BV || {});
  const T = window.BV_THEME || { t: {}, routes: {} };
  const R = T.routes || {};
  const t = (k, vars) => String((T.t || {})[k] || k).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, v) => (vars && vars[v] !== undefined ? vars[v] : ''));

  // ---------------------------------------------------------------- Header: predictive search
  const panel = $('#search');
  if (panel) {
    const input = $('#search-input', panel);
    const idle = $('[data-search-idle]', panel);
    const out = $('[data-search-results]', panel);
    const status = $('#search-status', panel);
    const cache = new Map();
    let ctrl = null;
    let timer;
    let slow;
    const skeleton = () => {
      const line = (w) => `<span class="bv-skel bv-skel--line" style="width:${w}%" aria-hidden="true"></span>`;
      const card = '<div class="bv-skel-card" aria-hidden="true"><span class="bv-skel bv-skel--media"></span><span class="bv-skel bv-skel--line"></span><span class="bv-skel bv-skel--price"></span></div>';
      return `<div class="bv-search__cols" aria-hidden="true"><div class="bv-skel-stack">${[60, 74, 52, 66].map(line).join('')}</div><div class="bv-search__pieces">${card.repeat(4)}</div></div>`;
    };
    const show = (html, q) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ps = $('[data-ps]', doc);
      if (!ps) return;
      out.innerHTML = ps.innerHTML;
      out.removeAttribute('aria-busy');
      const d = ps.dataset;
      const n = Number(d.psPieces) + Number(d.psCols) + Number(d.psPages);
      status.textContent = n ? t('search_status', { pieces: d.psPieces, cols: d.psCols, pages: d.psPages }) : t('search_none');
      BV.watchImages && BV.watchImages(out);
      out.dataset.q = q;
    };
    const run = () => {
      const q = input.value.trim();
      clearTimeout(slow);
      if (ctrl) ctrl.abort();
      if (q.length < 2) { idle.hidden = false; out.hidden = true; out.innerHTML = ''; status.textContent = ''; return; }
      idle.hidden = true;
      out.hidden = false;
      if (cache.has(q)) { show(cache.get(q), q); return; }
      slow = setTimeout(() => { out.setAttribute('aria-busy', 'true'); out.innerHTML = skeleton(); }, 200);
      ctrl = new AbortController();
      const url = `${R.predictive_search || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,query&resources[limit]=4&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=predictive-search`;
      fetch(url, { signal: ctrl.signal }).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((html) => { clearTimeout(slow); cache.set(q, html); if (input.value.trim() === q) show(html, q); })
        .catch((e) => { clearTimeout(slow); if (e.name !== 'AbortError') { out.removeAttribute('aria-busy'); out.innerHTML = ''; out.hidden = true; idle.hidden = false; } });
    };
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 120); });
    panel.addEventListener('click', (e) => {
      const s = e.target.closest('[data-suggest]');
      if (!s) return;
      e.preventDefault();
      input.value = s.dataset.suggest;
      run();
      input.focus();
    });
    // The Search button and Enter: the full results page (products, prefix matching on the last word). The address is
    // built here from the form's own action, so the panel always lands on /search?q=… whatever else is on the page;
    // without this script the form still submits natively to the same address.
    const form = $('form', panel);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const q = input.value.trim();
      if (q.length < 2) { input.focus(); return; }
      const url = new URL(form.getAttribute('action') || R.search || '/search', location.origin);
      url.search = '';
      url.searchParams.set('q', q);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      location.assign(url.href);
    });
    panel.addEventListener('bv:drawer-open', () => { input.select(); });
  }

  // ---------------------------------------------------------------- Tabs: search results (Pieces · Categories & help) and the wishlist sign-in panel
  $$('[data-sr-tabs], [data-signin-tabs]').forEach((list) => {
    const tabs = $$('[role="tab"]', list);
    const select = (tab, focus) => {
      tabs.forEach((x) => {
        const on = x === tab;
        x.setAttribute('aria-selected', String(on));
        x.tabIndex = on ? 0 : -1;
        const p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
    };
    list.addEventListener('click', (e) => { const x = e.target.closest('[role="tab"]'); if (x) select(x); });
    list.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      const k = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (k === undefined) return;
      e.preventDefault();
      select(tabs[(k + tabs.length) % tabs.length], true);
    });
  });
})();
